import { Grid } from '@mui/material';
import Search from './components/Search';
import MetaDataMap from './components/MetaDataMap';
import SelectedBuildingMetadata from './components/SelectedBuildingMetadata';
import styles from './NewBuilding.module.css';

export default function NewBuilding() {
    return (
        <Grid container spacing={2}>
            <Grid size={12} spacing={2}>
                <Search />
            </Grid>
            <Grid size={12} container direction="row" spacing={1} className={styles.tagging}>
                <Grid size={7} className={styles.map}>
                    <MetaDataMap />
                </Grid>
                <Grid size={4}>
                    <SelectedBuildingMetadata />
                </Grid>
            </Grid>
        </Grid>
    );
}
